import {useLazyQuery, gql} from '@apollo/client';
import {dashboardToken} from '../schema-types/dashboardToken';

export const DASHBOARD_TOKEN = gql`
  query dashboardToken {
    dashboardCredentials {
      id
      embedUrl
      embedToken
    }
  }
`;

export function useGetDashboardToken() {
  const [
    getDashboardToken,
    {
      data: dashboardTokenData,
      loading: loadingDashboardToken,
      error: errorDashboardToken,
    },
  ] = useLazyQuery<dashboardToken>(DASHBOARD_TOKEN);

  return {
    dashboardToken: dashboardTokenData?.dashboardCredentials,
    loadingDashboardToken,
    errorDashboardToken,
    getDashboardToken,
  };
}
